export default function DropdownIcon() {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.37 8.56422C12.6471 8.25634 12.6221 7.78212 12.3142 7.50503C12.0063 7.22793 11.5321 7.25289 11.255 7.56078L12.37 8.56422ZM9 11.1875L8.44253 11.6892C8.58476 11.8473 8.78738 11.9375 9 11.9375C9.21261 11.9375 9.41524 11.8473 9.55747 11.6892L9 11.1875ZM6.74497 7.56078C6.46788 7.25289 5.99366 7.22793 5.68578 7.50503C5.37789 7.78212 5.35294 8.25634 5.63003 8.56422L6.74497 7.56078ZM16.5 9H15.75C15.75 12.7279 12.7279 15.75 9 15.75V16.5V17.25C13.5563 17.25 17.25 13.5563 17.25 9H16.5ZM9 16.5V15.75C5.27208 15.75 2.25 12.7279 2.25 9H1.5H0.75C0.75 13.5563 4.44365 17.25 9 17.25V16.5ZM1.5 9H2.25C2.25 5.27208 5.27208 2.25 9 2.25V1.5V0.75C4.44365 0.75 0.75 4.44365 0.75 9H1.5ZM9 1.5V2.25C12.7279 2.25 15.75 5.27208 15.75 9H16.5H17.25C17.25 4.44365 13.5563 0.75 9 0.75V1.5ZM11.8125 8.0625L11.255 7.56078L8.44253 10.6858L9 11.1875L9.55747 11.6892L12.37 8.56422L11.8125 8.0625ZM9 11.1875L9.55747 10.6858L6.74497 7.56078L6.1875 8.0625L5.63003 8.56422L8.44253 11.6892L9 11.1875Z"
        fill="#455468"
      />
    </svg>
  );
}
